import ShelfController from '../../../../core/shelf.controller';
import { syncAdminProductCatalog } from '../../../../components/common/lists';
import categoriesApi from '../../data/categories.api';

/** Categorías: list, create, rename and (de)activate Mimesa's product categories. */
class CategoriesController extends ShelfController {
    async initialize() {
        if (!this.isAuthenticated) {
            this.navigateLogin();
            return;
        }
        await this.loadCategories();
    }

    async loadCategories() {
        this.setState({ loading: true });
        try {
            const categories = await categoriesApi.requestCategories({ includeInactive: true });
            this.setState({ categories, loading: false });
        } catch (error) {
            this.props.onMessage?.('error', error.message);
            this.setState({ loading: false });
        }
    }

    get visibleCategories() {
        const { categories, search } = this.state;
        const term = (search || '').trim().toLowerCase();
        if (!term) return categories;
        return categories.filter((c) => c.value.toLowerCase().includes(term) || c.name.includes(term));
    }

    setSearch(search) {
        this.setState({ search });
    }

    openCreate() {
        this.setState({ editing: null, modalOpen: true });
    }

    openEdit(category) {
        this.setState({ editing: category, modalOpen: true });
    }

    closeModal() {
        this.setState({ modalOpen: false, editing: null });
    }

    /** Modal submit: creates, or renames the category being edited. */
    async saveCategory({ label }) {
        const { editing } = this.state;
        this.setState({ saving: true });
        try {
            if (editing) {
                await categoriesApi.requestUpdateCategory(editing.name, { label });
                this.props.onMessage?.('success', 'Categoría actualizada');
            } else {
                await categoriesApi.requestCreateCategory(label);
                this.props.onMessage?.('success', 'Categoría creada');
            }
            this.setState({ saving: false, modalOpen: false, editing: null });
            await this.afterChange();
        } catch (error) {
            this.setState({ saving: false });
            this.props.onMessage?.('error', error.message);
        }
    }

    async toggleActive(category) {
        try {
            await categoriesApi.requestUpdateCategory(category.name, { active: !category.active });
            this.props.onMessage?.('success', category.active ? 'Categoría desactivada' : 'Categoría activada');
            await this.afterChange();
        } catch (error) {
            this.props.onMessage?.('error', error.message);
        }
    }

    /** Reload the list and the admin's shared catalog, so product forms and filters see the change. */
    async afterChange() {
        await this.loadCategories();
        syncAdminProductCatalog({ force: true });
    }
}

export default CategoriesController;
